import { FleetAlarm } from "../models/types/voy-fleet-alarm-model.types";
import { AuthService, AuthorizationRoles } from "../services/auth-service";
import { Alarm, AlarmState, AlarmType } from "../services/types/fleet-alarms-service.types";

export type AlarmsByDate = {
    [key: string]: FleetAlarm[]
}

export const groupAlarmsByDate = (alarms: FleetAlarm[]): AlarmsByDate => {
    const alarmsByDate: AlarmsByDate = {};

    if (!alarms.length) {
        return alarmsByDate;
    }

    alarms.forEach(va => {
        const key = va.startTs.substr(0, 10)

        if (!alarmsByDate[key]) {
            alarmsByDate[key] = []
        }

        alarmsByDate[key].push(va)
    })

    return alarmsByDate;
}

export const showHandleAlarm = (alarm?: FleetAlarm) => {
    return AuthService.userHasRole(AuthorizationRoles.AlarmEdit) && (alarm?.alarmType !== AlarmType.HeavyWeather && alarm?.alarmType !== AlarmType.ParametricRoll);

}

// Filter weather alarms
// 1. Filter out alarms that are not active
// 2. Filter out alarms that are not Heavy weather or Parametric Roll
// 3. Filter out alarms that are not within the time frame (24 hours for Heavy Weather, 48 hours for Parametric Roll)
export const filterWeatherAlarms = (alarms: FleetAlarm[]): FleetAlarm[] => {
    let filteredAlarms = alarms.filter(alarm => {
        const isActiveAlarm = alarm.alarmState === AlarmState.Active;
        const isHeavyWeatherAlarm = alarm.alarmType === AlarmType.HeavyWeather && checkIfWeatherAlarmWithInTime(alarm, 24);
        const isParametricRollAlarm = alarm.alarmType === AlarmType.ParametricRoll && checkIfWeatherAlarmWithInTime(alarm, 48);

        return isActiveAlarm && (isHeavyWeatherAlarm || isParametricRollAlarm);
    });
    // Filter out alarms that are  the latest alarm for each unique imo
    return filterArrayByImo(filteredAlarms)
}

export const filterArrayByImo = (alarms: FleetAlarm[]): FleetAlarm[] => {
    // Use an object to store the max id (biggest id value will be holding the latest alarm )for each unique imo
    const heavyWeatherAlarm = alarms.filter(alarm => alarm.alarmType === AlarmType.HeavyWeather);
    const parametricRollAlarm = alarms.filter(alarm => alarm.alarmType === AlarmType.ParametricRoll);
    
    const latestHeavyWeatherAlarms = getLatestAlarms(heavyWeatherAlarm);
    const validHeavyWeatherEntries = latestHeavyWeatherAlarms?.filter((alarm,index) => checkIfWeatherAlarmWithInTime(alarm, 24));
    const latestParametricRollAlarms = getLatestAlarms(parametricRollAlarm);
    const validParametricRollEntries = latestParametricRollAlarms?.filter((alarm,index) => checkIfWeatherAlarmWithInTime(alarm, 48));

    return [...validHeavyWeatherEntries,...validParametricRollEntries];
}

const getLatestAlarms = (alarms: FleetAlarm[]) => {
    const imoMap: { [key: number]: FleetAlarm } = {};
    alarms.forEach(item => {
        const imo = item.imo;
        const id = item.id;
        
        if (!imoMap[imo] || id > imoMap[imo]?.id) {
            imoMap[imo] = item;
        }
    });

    const filteredArray = Object.values(imoMap);
    return filteredArray;
}

const checkIfWeatherAlarmWithInTime = (alarm: Alarm, time: number) => {
    const alarmStartDate = new Date(alarm.startTs);
    const currentDate = new Date();
    const alarmEndDate = new Date(alarm.endTs);
    const difference = alarmStartDate.getTime() - currentDate.getTime();
    const criticality = difference / (1000 * 60 * 60);
    const diff = alarmEndDate.getTime() - alarmStartDate.getTime();
    const duration = diff / (1000 * 60 * 60);
    if(alarm.alarmType === AlarmType.ParametricRoll){
        if(criticality<=48){
            return duration >= 3;
        }
        else{
            return duration >= 6;
        }
    }
    else{
        return criticality <= time;
    }
}
